import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FieldService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getCompanies() {
    return this.http.get("/Field/GetJBCompanies").toPromise();
  }

  getContracts(hQCo: number, form: string) {
    return this.http.get("/Field/GetContracts?hQCo=" + hQCo + "&form=" + form).toPromise();
  }

  getContractByjCJMKeyID(LastUsedJCJMKeyID: number) {
    return this.http.get("/Field/GetContract?jCJMKeyID=" + LastUsedJCJMKeyID).toPromise();
  }

  getBills(hQCo: number, contract: string) {
    return this.http.get("/Field/JBGetBills?hQCo=" + hQCo + "&contract=" + contract).toPromise();
  }

  getHuddleTypes() {
    var url = "/Field/GetHuddleTypes";
    return this.http.get(url).toPromise();
  }

  addEditHuddleType(huddleTypeID?: number, huddleTypeName?: string) {
    return this.http.post("/Field/AddEditHuddleType",
      {
        huddleTypeID: huddleTypeID,
        huddleTypeName: huddleTypeName
      }).toPromise();
  }

  getHuddlesToSchedule() {
    var url = "/Field/GetHuddlesToSchedule";
    return this.http.get(url).toPromise();
  }

  removeHuddleType(huddleTypeID?: number) {
    return this.http.post("/Field/RemoveHuddleType",
      {
        huddleTypeID: huddleTypeID
      }).toPromise();
  }

  addEditHuddle(requestObj: any) {
    return this.http.post("/Field/AddEditHuddle", {
      huddleTypeID: requestObj.huddleTypeID,
      huddleDateStr: requestObj.huddleDateStr,
      huddleLocation: requestObj.huddleLocation,
      ledByUserKeyID: requestObj.ledByUserKeyID,
      jCJMKeyID: requestObj.jCJMKeyID,
      huddleID: requestObj.huddleID,
      releventFromStr: requestObj.releventFromStr,
      releventToStr: requestObj.releventToStr,
      isTemplateMeeting: requestObj.isTemplateMeeting,
      huddleName: requestObj.huddleName,
      isPublished: requestObj.isPublished,
      startTimeStr: requestObj.startTimeStr,
      notes: requestObj.notes
    }).toPromise();
  }

  initializeTemplateMeeting(templateHuddleID?: number, huddleDateStr?: string) {
    return this.http.post("/Field/InitializeTemplateMeeting",
      {
        templateHuddleID: templateHuddleID,
        huddleDateStr: huddleDateStr
      }).toPromise();
  }

  getHuddles(requestObj: any) {
    var url = "/Field/GetHuddles?huddleID=" + requestObj.huddleID + "&dateFromStr=" + requestObj.dateFromStr + "&dateToStr=" + requestObj.dateToStr + "&templateMode=" + requestObj.templateMode + "&branchID=" + requestObj.branchID + "&jCJMKeyID=" + requestObj.jCJMKeyID + "&workTypeID=" + requestObj.workTypeID + "&phaseTypeID=" + requestObj.phaseTypeID
    return this.http.get(url).toPromise();
  }

  getWorkTypes() {
    var url = "/Field/GetWorkTypes";
    return this.http.get(url).toPromise();
  }

  getPhaseTypes(workTypeID?: number) {
    var url = "/Field/GetPhaseTypes?workTypeID=" + workTypeID;
    return this.http.get(url).toPromise();
  }

  getTalkingPoints(phaseTypeID?: number, workTypeID?: number) {
    var url = "/Field/GetTalkingPoints?phaseTypeID=" + phaseTypeID + "&workTypeID=" + workTypeID;
    return this.http.get(url).toPromise();
  }

  deleteHuddle(huddleID?: number) {
    return this.http.post("/Field/DeleteHuddle",
      {
        huddleID: huddleID
      }).toPromise();
  }

  getJobs(form: string, searchString: string, JCCo: string) {
    var url = "/Field/GetJobs?form=" + form + "&searchString=" + searchString + "&JCCo=" + JCCo;
    return this.http.get(url).toPromise();
  }

  getPointsByHuddle(huddleID: number) {
    var url = "/Field/GetPointsByHuddle?huddleID=" + huddleID;
    return this.http.get(url).toPromise();
  }

  getDBAttachmentList(moduleID: number, recordID: number, recordGuid: any, onboardingUser: boolean) {
    var url = "/Document/GetDBAttachmentList?moduleID=" + moduleID + "&recordID=" + recordID + "&recordGuid=" + recordGuid + "&onboardingUser=" + onboardingUser;
    return this.http.get(url).toPromise();
  }

  addEditAttendee(requestObj: any) {
    return this.http.post("/Field/AddEditAttendee", {
      attendeeUserKeyID: requestObj.attendeeUserKeyID,
      attendeeSignature: requestObj.attendeeSignature,
      coachUserKeyID: requestObj.coachUserKeyID,
      signatureLatitude: requestObj.signatureLatitude,
      signatureLongitude: requestObj.signatureLongitude,
      huddleID: requestObj.huddleID,
      huddleAttendeeID: requestObj.huddleAttendeeID,
      attendeeSignatureDateStr: requestObj.attendeeSignatureDateStr
    }).toPromise();
  }

  getAttendees(huddleID: number, includeSigData: boolean) {
    var url = "/Field/GetAttendees?huddleID=" + huddleID + "&includeSigData=" + includeSigData;
    return this.http.get(url).toPromise();
  }

  deleteDBAttachment(fileAttachmentID: any) {
    return this.http.post("/Document/DeleteDBAttachment", {
      fileAttachmentID: fileAttachmentID
    }).toPromise();
  }
  copyAttendees(fromHuddleID?: number, toHuddleID?: number) {
    return this.http.post("/Field/CopyAttendees",
      {
        fromHuddleID: fromHuddleID,
        toHuddleID: toHuddleID
      }).toPromise();
  }

  removePointFromHuddle(huddleItemID?: number) {
    return this.http.post("/Field/RemovePointFromHuddle",
      {
        huddleItemID: huddleItemID
      }).toPromise();
  }

  addPointToHuddle(huddleID: number, talkingPointID?: number[]) {
    return this.http.post("/Field/AddPointToHuddle",
      {
        huddleID: huddleID,
        talkingPointID: talkingPointID
      }).toPromise();
  }

  removeAttendee(huddleAttendeeID?: number) {
    return this.http.post("/Field/RemoveAttendee",
      {
        huddleAttendeeID: huddleAttendeeID
      }).toPromise();
  }

  deleteTalkingPoint(talkingPointID: number) {
    return this.http.post("/Field/DeleteTalkingPoint",
      {
        talkingPointID: talkingPointID
      }).toPromise();
  }

  addEditTalkingPoint(requestObj: any) {
    return this.http.post("/Field/AddEditTalkingPoint",
      {
        talkingPointID: requestObj.talkingPointID,
        phaseTypeID: requestObj.phaseTypeID,
        talkingPointTitle: requestObj.talkingPointTitle,
        talkingPointBody: requestObj.talkingPointBody,
        isStandard: requestObj.isStandard,
        relatedTask: requestObj.relatedTask
      }).toPromise();
  }

  addEditWorkType(workTypeID: number, workTypeName: string, sortSeq?: number) {
    return this.http.post("/Field/AddEditWorkType",
      {
        workTypeID: workTypeID,
        workTypeName: workTypeName,
        sortSeq: sortSeq
      }).toPromise();
  }

  deleteWorkType(workTypeID?: number) {
    return this.http.post("/Field/DeleteWorkType",
      {
        workTypeID: workTypeID
      }).toPromise();
  }

  addEditPhaseType(phaseTypeID: number, workTypeID: number, phaseTypeName: number, sortSeq?: number) {
    return this.http.post("/Field/AddEditPhaseType",
      {
        phaseTypeID: phaseTypeID,
        workTypeID: workTypeID,
        phaseTypeName: phaseTypeName,
        sortSeq: sortSeq
      }).toPromise();
  }

  deletePhaseType(phaseTypeID?: any) {
    return this.http.post("/Field/DeletePhaseType",
      {
        phaseTypeID: phaseTypeID
      }).toPromise();
  }

  getCostTypes(co: number, contract: string) {
    var url = "/Field/GetCostTypes?co=" + co + "&contract=" + contract
    return this.http.get(url).toPromise();
  }

  getPhaseByContract(co: number, contract: string) {
    var url = "/Field/GetPhaseByContract?co=" + co + "&contract=" + contract
    return this.http.get(url).toPromise();
  }

  getAttachmentsDetail(jBINKeyID: number, co: number, contract: string) {
    var url = "/Field/GetAttachmentsDetail?jBINKeyID=" + jBINKeyID + "&co=" + co + "&contract=" + contract
    return this.http.get(url).toPromise();
  }

  updateAttachmentOrder(fromBillAttachmentID: number, toBillAttachmentID: number, newSequence: number, billType: string) {
    return this.http.post("/Field/UpdateAttachmentOrder",
      {
        fromBillAttachmentID: fromBillAttachmentID,
        toBillAttachmentID: toBillAttachmentID,
        newSequence: newSequence,
        billType: billType
      }).toPromise();
  }

  copyAttachment(attachmentID: number, jBINKeyID: number, moduleID: number) {
    return this.http.post("/Field/CopyAttachment",
      {
        attachmentID: attachmentID,
        jBINKeyID: jBINKeyID,
        moduleID: moduleID
      }).toPromise();
  }

  addBulkAttendees(huddleID: number, pRCo: number, pRCRKeyID: number) {
    return this.http.post("/Field/AddBulkAttendees",
      {
        huddleID: huddleID,
        PRCo: pRCo,
        PRCRKeyID: pRCRKeyID
      }).toPromise();
  }
  addBillAttachment(jBINKeyID: number, attachmentID: number) {
    return this.http.post("/Field/AddBillAttachment",
      {
        jBINKeyID: jBINKeyID,
        attachmentID: attachmentID
      }).toPromise();
  }

  renameAttachment(renamedfile: string, description: string, attachmentID: number, jBINKeyID: number) {
    return this.http.post("/Field/RenameAttachment", {
      renamedfile: renamedfile,
      description: description,
      attachmentID: attachmentID,
      jBINKeyID: jBINKeyID
    }).toPromise();
  }

  excludeIncludeAttachment(billAttachmentID: number, isExclude: boolean) {
    return this.http.post("/Field/ExcludeIncludeAttachment", {
      billAttachmentID: billAttachmentID,
      isExclude: isExclude
    }).toPromise();
  }

  initializeAttachments(jCCo: number, contract: string, jBINKeyID: number, phase: string, begMthString: string, endMthString: string, begDateString: string, endDateString: string, costType: number, sortOrder: string) {
    return this.http.post("/Field/InitializeAttachments", {
      jCCo: jCCo,
      contract: contract,
      jBINKeyID: jBINKeyID,
      phase: phase,
      begMthString: begMthString,
      endMthString: endMthString,
      begDateString: begDateString,
      endDateString: endDateString,
      costType: costType,
      sortOrder: sortOrder
    }).toPromise();
  }

  compileAndSavePDFData(company: number, jBINKeyID: number, billNumber: number, billMonthString: string, begDateString: string, endDateString: string, inclJCDetail: boolean
    , showArchitect: boolean, showOwner: boolean, phases: string, contract: string, breakDetail: boolean, restrictByBillNumber: boolean, begMthString: string, endMthString: string, sortOrder: string) {
    return this.http.post("/Field/CompileAndSavePDFData", {
      company: company,
      jBINKeyID: jBINKeyID,
      billNumber: billNumber,
      billMonthString: billMonthString,
      begDateString: begDateString,
      endDateString: endDateString,
      inclJCDetail: inclJCDetail,
      showArchitect: showArchitect,
      showOwner: showOwner,
      phases: phases,
      contract: contract,
      breakDetail: breakDetail,
      restrictByBillNumber: restrictByBillNumber,
      begMthString: begMthString,
      endMthString: endMthString,
      sortOrder: sortOrder
    }).toPromise();
  }

  downloadCompilePDFFile(billMonthString: string, begDateString: string, endDateString: string, contract: string, billNumber: number) {
    var url = "/Field/DownloadCompilePDFFile?contract=" + contract + "&billMonthString=" + billMonthString +
      "&begDateString=" + begDateString +
      "&endDateString=" + endDateString +
      "&billNumber=" + billNumber
    return this.http.get(url).toPromise();
  }

  compileAndSaveZIPData(company: number, jBINKeyID: number, billNumber: number, billMonthString: string, begDateString: string, endDateString: string, inclJCDetail: boolean
    , showArchitect: boolean, showOwner: boolean, phases: string, contract: string, breakDetail: boolean, restrictByBillNumber: boolean, begMthString: string, endMthString: string, sortOrder: string) {
    return this.http.post("/Field/CompileAndSaveZIPData", {
      company: company,
      jBINKeyID: jBINKeyID,
      billNumber: billNumber,
      billMonthString: billMonthString,
      begDateString: begDateString,
      endDateString: endDateString,
      inclJCDetail: inclJCDetail,
      showArchitect: showArchitect,
      showOwner: showOwner,
      phases: phases,
      contract: contract,
      breakDetail: breakDetail,
      restrictByBillNumber: restrictByBillNumber,
      begMthString: begMthString,
      endMthString: endMthString,
      sortOrder: sortOrder
    }).toPromise();
  }

  downloadCompileZIPFile(billMonthString: string, begDateString: string, endDateString: string, contract: string, billNumber: number) {
    var url = "/Field/DownloadCompileZIPFile?contract=" + contract + "&billMonthString=" + billMonthString +
      "&begDateString=" + begDateString +
      "&endDateString=" + endDateString +
      "&billNumber=" + billNumber
    return this.http.get(url).toPromise();

  }

  getPOVendors(pOCo?: number, searchString?: string) {
    var url = "/Field/GetPOVendors?pOCo=" + pOCo + "&searchString=" + searchString;
    return this.http.get(url).toPromise();
  }

  getPOItemByAPULKeyID(apULKeyID: number) {
    var url = "/Field/GetPOItemByAPULKeyID?aPULKeyID=" + apULKeyID;
    return this.http.get(url).toPromise();
  }

  getJCPhaseDesc(jcco: number, job: any, phase: any, apco: any) {
    var url = "/Field/GetJCPhaseDesc?jcco=" + jcco + "&job=" + job + "&phase=" + phase + "&apco=" + apco;
    return this.http.get(url).toPromise();
  }

  getMaterialInfo(rQCo?: number, material?: string) {
    var url = "/Field/GetMaterialInfo?rQCo=" + rQCo + "&material=" + material;
    return this.http.get(url).toPromise();
  }

}
